const ANCHOR_GAP = 8
const VIEWPORT_MARGIN = 12
/** Prefer flipping when remaining space on the preferred side is below this. */
const FLIP_THRESHOLD = 200

/**
 * Compute fixed-viewport panel style so the sheet sits near an anchor rect
 * (prefer below; flip above when needed) and stays fully on-screen.
 * @param {{ top: number, bottom: number, left?: number, right?: number, width?: number, height?: number } | null} anchorRect
 * @param {number} [preferredMaxHeight]
 * @param {{ placement?: 'auto' | 'below' }} [options]
 */
export function getAnchoredBottomSheetStyle(
  anchorRect,
  preferredMaxHeight = null,
  options = {},
) {
  if (!anchorRect || typeof window === 'undefined') return null

  const vh = window.innerHeight
  const spaceBelow = Math.max(0, vh - anchorRect.bottom - ANCHOR_GAP - VIEWPORT_MARGIN)
  const spaceAbove = Math.max(0, anchorRect.top - ANCHOR_GAP - VIEWPORT_MARGIN)
  const preferredMax = preferredMaxHeight
    ?? Math.min(vh * 0.66, 720)
  const forceBelow = options.placement === 'below'
  const placeBelow = forceBelow
    || spaceBelow >= FLIP_THRESHOLD
    || spaceBelow >= spaceAbove
  const available = placeBelow ? spaceBelow : spaceAbove
  const maxHeight = Math.min(preferredMax, available)

  if (maxHeight <= 0) return null

  if (placeBelow) {
    return {
      position: 'absolute',
      top: Math.max(VIEWPORT_MARGIN, anchorRect.bottom + ANCHOR_GAP),
      left: VIEWPORT_MARGIN,
      right: VIEWPORT_MARGIN,
      bottom: 'auto',
      width: 'auto',
      maxWidth: 'none',
      height: 'auto',
      maxHeight,
    }
  }

  return {
    position: 'absolute',
    top: 'auto',
    bottom: Math.max(VIEWPORT_MARGIN, vh - anchorRect.top + ANCHOR_GAP),
    left: VIEWPORT_MARGIN,
    right: VIEWPORT_MARGIN,
    width: 'auto',
    maxWidth: 'none',
    height: 'auto',
    maxHeight,
  }
}
